import styled, { css } from 'styled-components';

// FontAwesome.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// The icon's own width plus the gap that keeps it off the name.
export const ICON_SPACE = '1.6em';

// The icon lies over the end padding, so a chip at rest is as wide as its name.
export const Chip = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  min-width: 0;
  /* WA's own badge padding, so a secret matches the badges above it. */
  padding: 0.375em 0.625em;
  border: 0;
  border-radius: var(--border-radius);
  background: var(--bg-1);
  color: var(--text);
  font: inherit;
  line-height: 1.3;
  text-align: left;
  cursor: pointer;
  transition: padding-inline-end 0.15s ease;

  &:hover,
  &:focus-visible {
    padding-inline-end: calc(var(--xs-padding-horizontal) + ${ICON_SPACE});
  }

  /* The check outlives the hover, so the room for it does too. */
  ${({ $copied }) =>
    $copied &&
    css`
      padding-inline-end: calc(var(--xs-padding-horizontal) + ${ICON_SPACE});
    `}

  /* Without hover there is nothing to reveal the icon, so it is always out. */
  @media (hover: none) {
    padding-inline-end: calc(var(--xs-padding-horizontal) + ${ICON_SPACE});
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
`;

export const Name = styled.code`
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 0.9em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// Both icons stay mounted and fade, so the check never swaps back to copy mid-fade.
const Icon = styled(FontAwesomeIcon)`
  position: absolute;
  inset-inline-end: var(--xs-padding-horizontal);
  top: 50%;
  transform: translateY(-50%);
  flex-shrink: 0;
  font-size: 0.75em;
  color: var(--text-muted);
  transition: opacity 0.15s ease;

  /* The kit carries copy in light only, so a stroke gives it the weight of the text. */
  path {
    stroke: currentColor;
    stroke-width: 20;
    paint-order: stroke;
  }
`;

export const CopyIcon = styled(Icon)`
  @media (hover: hover) {
    opacity: 0;

    ${Chip}:hover &,
    ${Chip}:focus-visible & {
      opacity: 1;
    }
  }

  ${Chip}[data-copied] && {
    opacity: 0;
  }
`;

export const CheckIcon = styled(Icon)`
  font-size: 0.9em;
  color: var(--green);
  opacity: 0;

  ${Chip}[data-copied] & {
    opacity: 1;
  }
`;
